<div class="row mt-3">
  <div class="col-4">

  </div>

  <div class="col-4"></div>
  <div class="col-4">
    <div class="d-flex align-items-center justify-content-end">
      <button class="btn btn-clear ms-2">
        <i class=" fa-light fa-bell fa-2xl text-primary"></i>
      </button>
      <a href="">
        <div class="img">
          <img src="profile.png" class="img-fluid rounded-circle" alt="" srcset="">
        </div>
      </a>
    </div>
  </div>
</div>
<div class="mt-3">
  <div class="d-flex justify-content-between align-items-center py-3">
    <a [routerLink]="['/home']"><i class="fa fa-light fa-arrow-left fa-xl"></i></a>
  </div>
</div>

<div class="my-3">
  <h3>Transfer</h3>
  <p>You can make your order payment by transfer to the account details</p>
</div>
<br>
<div class="mt-3">
  <p>Account Name</p>
  <h5>African Stomach House</h5>
</div>
<div class="mt-3">
  <p>Account Number</p>
  <h5>0123456789</h5>
</div>
<div class="mt-3">
  <p>Bank Name</p>
  <h5>African City Bank</h5>
</div>


<div class="bottom">
  <div class="row">
    <div class="col-6 offset-3 text-center">
      <button class="btn btn-primary btn-block" (click)="confirm()">Confirm Payment</button>
    </div>
  </div>
</div>
